/* eslint-disable react-doctor/use-lazy-motion */
import { motion, type MotionProps } from "framer-motion";
import type { ReactNode } from "react";
import { ProviderType } from "@wags/catalog/pure.ts";
import { ProviderMeta, type ProviderMetaStat } from "../provider-meta";
import { ProviderVerifiedName } from "../provider-verified-name";

export function ShelterHero({
    organizationName,
    isVerified,
    organizationType,
    locationDisplay,
    stats,
    website,
    cta,
    entrance,
}: {
    organizationName: string;
    isVerified?: boolean;
    organizationType: string;
    locationDisplay: string;
    stats: ProviderMetaStat[];
    website?: string;
    cta?: ReactNode;
    entrance: (delay?: number) => MotionProps;
}) {
    return (
        <>
            <motion.div className="flex w-full flex-col" {...entrance()}>
                <p className="text-body text-doberman-black/80 text-pretty">
                    {organizationType}
                </p>
                <div className="mt-2 md:flex md:items-center md:justify-between md:gap-12">
                    <h1 className="min-w-0 text-page-title text-doberman-black text-balance">
                        <ProviderVerifiedName
                            name={organizationName}
                            isVerified={isVerified}
                            providerType={ProviderType.ShelterRescue}
                        />
                    </h1>
                    {cta && (
                        <div className="hidden md:block md:shrink-0">{cta}</div>
                    )}
                </div>
            </motion.div>

            {(locationDisplay || stats.length > 0 || website) && (
                <motion.div className="mt-4" {...entrance()}>
                    <ProviderMeta
                        location={locationDisplay}
                        stats={stats}
                        website={website}
                    />
                </motion.div>
            )}
        </>
    );
}
